import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_ESPLETATO_OK_CHECKLIST_GISFO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDEspletatoOkChecklistGISFOState extends EntityState<IID_ESPLETATO_OK_CHECKLIST_GISFO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_ESPLETATO_OK_CHECKLIST_GISFO , realtimeEntity: 'IID_EspletatoOkChecklistGisfo'})
@InterfaceDataStore(InterfaceName.ESPLETATO_OK_CHECKLIST_GISFO)
export class IIDEspletatoOkChecklistGISFOStore extends EntityStore<IIDEspletatoOkChecklistGISFOState> {
  constructor() {
    super([]);
  }
}
